import {exportHeight, exportWidth} from "../constants/outputConstants";
import {setBox3FromObjectArray} from "../utils/threeUtils";
import {getFixedPerspectiveCameraPosition, scene} from "../sceneManager";
import {disableAllLayers, disableLayer, enableAllLayers, enableLayerById} from "../utils/layerUtils";
import * as Globals from "../globals";
import {OrbitControls} from "../override/OrbitControls2";
import {sceneView} from "../main";
import {MOUSE,WebGLRenderer, WebGLRenderTarget} from "three";
import {fitPerspectiveCameraToBounds, zoomOrthographicCameraToBounds} from "../utils/cameraUtils";

const saveImageUrl = "/configurator/save-image";

export class ImageExport {
    constructor(/* renderer, renderTarget, */ view, objects, projectId, options = {}) {
        this.options = {
            layers: null,
            downsamplingFactor: 1,
            uploadImage: true,
            cameraPosition: null,
            copyCameraMatrix: null,
            width: null,
            height: null,
            ...options
        };

        this.view = view;

        
        

        //Finale Bildauflösung
        if (this.options.width !== null && this.options.height !== null) {
            this.width = this.options.width * this.options.downsamplingFactor;
            this.height = this.options.height * this.options.downsamplingFactor;
        } else {
            this.width = exportWidth * this.options.downsamplingFactor;
            this.height = exportHeight * this.options.downsamplingFactor;
        }

        //Auflösung für den renderer. Ist erhöht für späteres Downsampling > Aliasing verhindern
        this.renderWidth = this.width;
        this.renderHeight = this.height;

        this.fileName = this.view.name; //Dateiname
        this.projectId = projectId; //ID des Projekts > Teil des Ordnerpfads

        this.originalCamera = this.view.camera; //Camera auf dessen Basis das Bild erstellt wird
        this.camera = this.originalCamera.clone(); //Wird geclont um die Ursprungseinstellungen der Kamera nicht verändern zu müssen.

        if (this.options.cameraPosition !== null) {
            this.camera.position.copy(this.options.cameraPosition);
        }

        if (this.camera.isPerspectiveCamera) {
            this.controls = new OrbitControls(this.camera, sceneView); //Regular controls
            this.controls.mouseButtons = {
                LEFT: MOUSE.ROTATE, MIDDLE: null, RIGHT: MOUSE.PAN
            };
            this.controls.minDistance = 1;
            this.controls.maxDistance = 50;
        } else {
            this.controls = new OrbitControls(this.camera, sceneView);
            this.controls.enableRotate = false;
            this.controls.enablePan = true;
            this.controls.enableZoom = true;
            this.controls.mouseButtons = {LEFT: null, MIDDLE: null, RIGHT: MOUSE.PAN};
            this.controls.minZoom = 0.2;
            this.controls.maxZoom = 7.5;
        }

        this.objects = objects; //Objekte die sichtbar sein sollen
        this.bounds = setBox3FromObjectArray(this.objects); //Bounds der Elemente

/*         this.outputRenderTarget = renderTarget;
        this.outputRenderer = renderer; */
       /*  this.setupRendererProperties(); */

        //Kopieren der Positionierung der übergebenen Kamera. Oder default Position mit Autozoom
        this.setCameraValues(); //Kameraeinstellung setzen und and die bounds zoomen

       /*  this.outputRenderer.render(scene, this.camera); //Frame rendern */
        this.imageDataURL = null;

        this.generateImage();

        //Dispose der nicht mehr benötigten Elemente
        this.dispose();
    }

    setupRendererProperties() {
        //Set renderer properties
/*         this.outputRenderer.setSize(this.renderWidth, this.renderHeight);
        this.outputRenderer.setRenderTarget(this.outputRenderTarget);
        this.outputRenderer.setPixelRatio(window.devicePixelRatio); */
    }

    setCameraValues() {
        
        this.setLayers();

        if (this.camera.isPerspectiveCamera) {
            this.camera.aspect = this.renderWidth / this.renderHeight;

            if (this.options.copyCameraMatrix) {
                this.camera.position.copy(this.originalCamera.position);
                this.camera.quaternion.copy(this.originalCamera.quaternion);
                this.camera.scale.copy(this.originalCamera.scale);
                this.camera.updateMatrixWorld();
            } else {
                if (this.fileName === "perspective-3d") {
                    this.camera.position.copy(getFixedPerspectiveCameraPosition(this.fileName));
                }
                fitPerspectiveCameraToBounds(this.camera, this.controls, this.bounds);
            }
        } else if (this.camera.isOrthographicCamera) {
            let desiredAspect = this.renderWidth / this.renderHeight;
            this.camera.zoom = 1;
            this.camera.updateProjectionMatrix();

            zoomOrthographicCameraToBounds(this.camera, this.bounds, desiredAspect, 1.2, this.controls);
        } else {
            throw new Error('Invalid camera type');
        }

        this.camera.updateProjectionMatrix();
    }

    setLayers() {
        
        if (this.options.layers === null) {
            enableAllLayers(this.camera);
            disableLayer(this.camera, Globals.layers.hidden);
        } else {
            disableAllLayers(this.camera);
            for (let i = 0; i < this.options.layers.length; i++) {
                let id = this.options.layers[i];
                enableLayerById(this.camera, id);
            }
        }
    }

    generateImage() {


        const renderTarget = new WebGLRenderTarget(this.renderWidth, this.renderHeight, {
            samples: 4
        }); 
        // Create renderer
        const renderer = new WebGLRenderer({ antialias: true });
        renderer.setSize(this.renderWidth, this.renderHeight); // HD resolution
        renderer.setPixelRatio(window.devicePixelRatio);
        renderer.setRenderTarget(renderTarget);
    
        // Create render target for better quality
    
               // Render the scene
        renderer.render(scene, this.camera);
    
        // Create canvas and get context
        const canvas = document.createElement('canvas');
        canvas.width = this.renderWidth;
        canvas.height = this.renderHeight;
        const context = canvas.getContext('2d');
    
        // Read pixels from render target
        const pixelBuffer = new Uint8Array(this.renderWidth * this.renderHeight * 4);
        renderer.readRenderTargetPixels(renderTarget, 0, 0, this.renderWidth, this.renderHeight, pixelBuffer);
    
        // Create image data and put on canvas
        const imageData = new ImageData(new Uint8ClampedArray(pixelBuffer), this.renderWidth, this.renderHeight);
        context.putImageData(imageData, 0, 0);
    
        // Flip the image (WebGL coordinate system is different)
        context.scale(1, -1);
        context.translate(0, -this.renderHeight);
        context.drawImage(canvas, 0, 0);
    
        // Get base64 encoded image
        if (this.options.downsamplingFactor > 1) {
            // Create the final downscaled canvas
            let finalCanvas = document.createElement('canvas');
            finalCanvas.width = this.width;
            finalCanvas.height = this.height;
            let finalContext = finalCanvas.getContext('2d');

            // Draw the processed canvas onto the final downscaled canvas
            finalContext.drawImage(canvas, 0, 0, this.renderWidth, this.renderHeight, 0, 0, this.width, this.height);

            this.imageDataURL = finalCanvas.toDataURL('image/png');
        } else {
            this.imageDataURL = canvas.toDataURL('image/png');
        }

        // Send the generated image to the server
        if (this.options.uploadImage) {
            this.saveImageToServer();
        }
    
        // Cleanup
        renderTarget.dispose();
        renderer.dispose();
        renderer.forceContextLoss();
        //scene.clear();
       
        //return base64Image;
        
        // Read the pixel data from the render target;
        /* let pixelBuffer = new Uint8Array(this.renderWidth * this.renderHeight * 4);
        this.outputRenderer.readRenderTargetPixels(this.outputRenderTarget, 0, 0, this.renderWidth, this.renderHeight, pixelBuffer);

        // Create an ImageData object and put the pixel data onto a canvas
        let imageData = new ImageData(new Uint8ClampedArray(pixelBuffer), this.renderWidth, this.renderHeight);

        // Create a canvas for flipping and other operations
        let canvas = document.createElement('canvas');
        canvas.width = this.renderWidth;
        canvas.height = this.renderHeight;
        let context = canvas.getContext('2d');

        // Put the ImageData onto the canvas
        context.putImageData(imageData, 0, 0);
        context.scale(1, -1);
        context.translate(0, -this.renderHeight);
        context.drawImage(canvas, 0, 0);

        if (this.options.downsamplingFactor > 1) {
            // Create the final downscaled canvas
            let finalCanvas = document.createElement('canvas');
            finalCanvas.width = this.width;
            finalCanvas.height = this.height;
            let finalContext = finalCanvas.getContext('2d');

            // Draw the processed canvas onto the final downscaled canvas
            finalContext.drawImage(canvas, 0, 0, this.renderWidth, this.renderHeight, 0, 0, this.width, this.height);

            this.imageDataURL = finalCanvas.toDataURL('image/png');
        } else {
            this.imageDataURL = canvas.toDataURL('image/png');
        }

        // Send the generated image to the server
        if (this.options.uploadImage) {
            this.saveImageToServer();
        } */
    }

    saveImageToServer() {
        // Get the CSRF token value from the page (assuming it's stored in a <meta> tag)
        let csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

        if (this.imageDataURL === null) {
            throw new Error("No image available to send.");
        }

        fetch(saveImageUrl, {
            method: "POST",
            body: JSON.stringify({imageDataURL: this.imageDataURL, name: this.fileName, projectId: this.projectId}), // Use the original data URL
            async: false,
            headers: {
                "Content-Type": "application/json",
                "X-CSRF-TOKEN": csrfToken // Include the CSRF token in the header
            }
        }).then(() => {
            // console.log("Saved");
        });
    }

    dispose() {

    }
}
